import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import NotificationBell from '../../Icons/NotificationBell';
import FinancingTerms from '../../Icons/FinancingTerms';
import PersonalDetails from '../../Icons/PersonalDetails';
import LargeAccount from '../../Icons/LargeAccount';
import ReferralsNavIcon from '../../Icons/ReferralsNavIcon';
import PrivacySettingsIcon from '../../Icons/PrivacySettingsIcon';

export const NavigationIconContainer = styled.div``;

const DesktopNavigationIcons = css`
  margin-right: 23px;
  align-self: center;
  width: 13px;
  height: 15px;
  fill: ${(props: any) => props.theme.carvana.gray.medium};
`;

export const PersonalDetailsIcon = styled(PersonalDetails)`
  ${DesktopNavigationIcons};
`;

export const FinancingTermsIcon = styled(FinancingTerms)`
  ${DesktopNavigationIcons};
`;

export const NotificationBellIcon = styled(NotificationBell)`
  ${DesktopNavigationIcons};
`;

export const ReferralsIcon = styled(ReferralsNavIcon)`
  ${DesktopNavigationIcons};
  margin-top: 4px;
`;

export const PrivacySettings = styled(PrivacySettingsIcon)`
  ${DesktopNavigationIcons};
  margin-top: 2px;
`;

export const Navigation = styled.nav`
  display: flex;
  flex-flow: column;
  background-color: ${(props: any) => props.theme.carvana.blue.dark};
  padding: 50px 0px;
  width: 201px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    width: 276px;
  }
`;

export const NavigationLink = styled(NavLink)`
  &.activeTab {
    svg {
      fill: ${(props: any) => props.theme.carvana.blue.primary};
    }
    p {
      color: ${(props: any) => props.theme.carvana.blue.primary};
    }
    div {
      border-color: transparent ${(props: any) => props.theme.carvana.gray.background} transparent
        transparent;
    }
  }
`;

export const NavigationContainer = styled.ul`
  padding-left: 32px;
`;

export const NavigationItemContainer = styled.li`
  display: flex;
  color: ${(props: any) => props.theme.carvana.gray.light};
  font-weight: 700;
  padding: 8px 0px;
  align-items: flex-start;
`;

export const TriangleTab = styled.div`
  content: '';
  display: inline-block;
  position: relative;
  border: 10px solid ${(props: any) => props.theme.carvana.blue.dark};
  flex: 1;
`;

export const NavigationLabel = styled.p`
  display: inline-block;
  color: ${(props: any) => props.theme.carvana.gray.medium};
  font-weight: 700;
  align-self: center;
  text-transform: uppercase;
  max-width: 200px;
  font-size: 14px;
`;

export const AccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 28px;
`;

export const LargeAccountIcon = styled(LargeAccount)`
  align-self: center;
`;

export const AccountHeader = styled.p`
  color: ${(props: any) => props.theme.carvana.white.primary};
  letter-spacing: 0.3px;
  text-align: left;
  font-weight: 700;
  font-size: 24px;
  padding-top: 20px;
  align-self: center;

  &.is-center {
    text-align: center;
  }
`;

export const AccountEmail = styled.p`
  color: ${(props: any) => props.theme.carvana.gray.medium};
  font-size: 14px;
  padding-top: 10px;
  align-self: center;
`;
